import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnChanges,
	ElementRef, AfterViewInit
} from '@angular/core';

import { TopoMap, DisplayEdge, DashStyle } from '../../dtos/topology/TopoMap';
import { LicensingService } from 'identity';

@Component({
    selector: 'pen-pattern-selector',
	templateUrl: './pen-pattern-selector.component.html',
	styleUrls: ['./pen-pattern-selector.component.scss']
})
export class PenPatternSelectorComponent implements AfterViewInit, OnChanges {

	@Input()
	public lineColor: string;
	@Output()
	public lineColorChange: EventEmitter<string>;

	@Input()
	public lineWidth: number;
	@Output()
	public lineWidthChange: EventEmitter<number>;

	@Input()
	public lineDashStyle: string;
	@Output()
	public lineDashStyleChange: EventEmitter<string>;

	constructor(private elementRef: ElementRef, private licensingService: LicensingService) {
		this.lineColor = "#000000";
		this.lineColorChange = new EventEmitter<string>();

		this.lineWidth = 1;
		this.lineWidthChange = new EventEmitter<number>();

		this.lineDashStyle = "Solid";
		this.lineDashStyleChange = new EventEmitter<string>();
	}

	public ngAfterViewInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {

	}

	public get isLicenseValid(): boolean {
		//return this.licensingService.isLicenseValid;
		return true;
	}

	public onLineColorChange(event): void {
		this.lineColorChange.emit(this.lineColor);
	}

	public onLineWidthChange(event): void {
		this.lineWidthChange.emit(this.lineWidth);
	}

	public onLineDashStyleChange(event): void {
		this.lineDashStyleChange.emit(this.lineDashStyle);
	}

}